<lib-export-files-primary
  #exportFilesTab
  *ngIf="!showMappings && !showCheckMappings"
  (showMappings)="toggleMappings($event)"></lib-export-files-primary>
<lib-gl-mapping
  *ngIf="showMappings"
  (cancelClicked)="toggleMappings($event)"
  [config]="chosenConfig"></lib-gl-mapping>
<lib-gl-checks-mapping
  *ngIf="showCheckMappings"
  (finished)="toggleMappings($event)"
  [config]="chosenConfig"></lib-gl-checks-mapping>
